(function () {
  const INTERACTION_EVENTS = ['pointerdown', 'touchstart', 'keydown', 'wheel', 'mousemove', 'scroll'];
  const INTERACTION_FALLBACK_MS = 8000;
  const LISTENER_OPTIONS = { passive: true, capture: true };

  const firedTiers = {};
  const pendingCallbacks = { idle: [], interaction: [] };

  function activateScripts(tier) {
    const placeholders = document.querySelectorAll(
      'script[type="text/plain"][data-delayed-script="' + tier + '"]'
    );

    placeholders.forEach(function (placeholder) {
      const script = document.createElement('script');

      for (let i = 0; i < placeholder.attributes.length; i++) {
        const attribute = placeholder.attributes[i];
        if (attribute.name === 'type') continue;
        if (attribute.name === 'data-delayed-script') continue;
        if (attribute.name === 'data-delayed-src') continue;
        script.setAttribute(attribute.name, attribute.value);
      }

      const source = placeholder.getAttribute('data-delayed-src');
      if (source) {
        script.src = source;
        script.async = false;
      } else {
        script.textContent = placeholder.textContent;
      }

      placeholder.parentNode.insertBefore(script, placeholder);
      placeholder.parentNode.removeChild(placeholder);
    });
  }

  function activate(tier) {
    if (firedTiers[tier]) return;
    firedTiers[tier] = true;

    if (tier === 'interaction') {
      INTERACTION_EVENTS.forEach(function (name) {
        window.removeEventListener(name, onInteraction, LISTENER_OPTIONS);
      });
    }

    activateScripts(tier);

    const callbacks = pendingCallbacks[tier] || [];
    while (callbacks.length) callbacks.shift()();
  }

  function onInteraction() {
    activate('interaction');
  }

  function afterLoad(callback) {
    if (document.readyState === 'complete') {
      callback();
    } else {
      window.addEventListener('load', callback, { once: true });
    }
  }

  INTERACTION_EVENTS.forEach(function (name) {
    window.addEventListener(name, onInteraction, LISTENER_OPTIONS);
  });

  afterLoad(function () {
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(function () { activate('idle'); }, { timeout: 3000 });
    } else {
      setTimeout(function () { activate('idle'); }, 200);
    }
    setTimeout(function () { activate('interaction'); }, INTERACTION_FALLBACK_MS);
  });

  function register(entry) {
    const tier = entry[0] === 'idle' ? 'idle' : 'interaction';
    const callback = entry[1];
    firedTiers[tier] ? callback() : pendingCallbacks[tier].push(callback);
  }

  window.themeDelayedThirdParty = {
    onIdle: function (callback) { register(['idle', callback]); },
    onInteraction: function (callback) { register(['interaction', callback]); },
    activate: activate
  };

  const alreadyQueued = window.themeDelayedQueue || [];
  window.themeDelayedQueue = { push: register };
  alreadyQueued.forEach(register);
}());
